import React from "react"
import styled from "styled-components"
import { Col, FormGroup, Label, Row } from "reactstrap"
import SelectWithInput from "../../../../../../components/Common/SelectWithInput"
import PropTypes from "prop-types"

export const CAMPAIGN_BUDGET_KEY = "campaign-budget"

const options_budget = [
  { label: "Daily", value: "daily" },
  { label: "Lifetime", value: "lifetime" }
]

const TtCampaignBudget = ({ items, data }) => {
  const [isActive, setIsActive] = React.useState(false)

  React.useEffect(() => {
    setIsActive(false)
  }, [items])

  const hasItem = React.useMemo(() => items.some(i => i === CAMPAIGN_BUDGET_KEY), [items])
  if (!hasItem) return <></>

  return (
    <>
      <TtCampaignBudgetStyled>
        {!data.campaignBudgetOptimization && <div
          className="form-check form-switch form-switch-md"
        >
          <input
            type="checkbox"
            className="form-check-input"
            id={"is-" + CAMPAIGN_BUDGET_KEY}
            checked={isActive}
            onChange={e => setIsActive(e.target.checked)}
          />
          <label
            className="form-check-label mb-1"
            htmlFor={"is-" + CAMPAIGN_BUDGET_KEY}
          >Set campaign budget (USD)</label>
        </div>}
        {(isActive || data.campaignBudgetOptimization) && <>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                {data.campaignBudgetOptimization && <Label htmlFor="">Budget (USD):</Label>}
                <SelectWithInput
                  select_name={"campaign-budget_type"}
                  options={options_budget}
                  defaultValue={options_budget[0]}
                  required
                  // isLoading={isLoading}
                  inputOptions={{
                    name: "campaign-budget",
                    placeholder: "Al least 50.00",
                    value: "",
                    type: "number",
                    errorMessage: "Budget field is required!",
                    validate: { required: { value: true } }
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        </>}
      </TtCampaignBudgetStyled>
    </>
  )
}

TtCampaignBudget.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.object.isRequired
  // onChange: PropTypes.func.isRequired,
}

const TtCampaignBudgetStyled = styled.div`
  .select2-selection__control {
    margin-right: 0;
    min-width: 75px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
  }
  
  input.form-control {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    position: relative;
  }
`

export default (TtCampaignBudget)
